/* ZAKDOR - the globe behind the tracking page.

   A pale sphere turning slowly, the world's land drawn as a lattice of
   small dots, our warehouse pinned on it. ax-track.js decides what to
   show; this file only knows how to draw it. Exposed as window.__axGlobe.

   The land is a lattice of points sampled from Natural Earth (110m),
   packed as bits: LAND.rows rows 1.5 degrees apart from LAND.lat0
   northwards; each row holds floor(240 * cos(lat) + 0.5) points spread
   evenly around the globe (so the dots stay the same distance apart
   near the poles), odd rows shifted by half a step. */
(function () {
  if (window.__axGlobe) return;

  var HUB = { name: 'Zakdor', lat: 26.80, lon: 84.50 };
  var INDIA = { lat: 22.5, lon: 80.5 };

  var LAND = { step: 1.5, lat0: -56, rows: 94, b64: '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' };
  /* the same land twice as fine, for when the globe is zoomed in close */
  var FINE = { step: 0.75, lat0: 5, lat1: 38, lon0: 60, lon1: 100, rows: 45, b64: 'AAAAAACAAwAAAAAAAAAAAGAAAAAAAAAOAAAIAACAAQAAAQCAGQAAMAAA8AIAAAIAAA8AACAAAPABAAAEAIAfAABgAAD4AwAABADAHwAAYAAA/AMAAAYAwB8AAHAAAP4BAAADAPgfAMAcAMD/AwD+AAD+PwDwBwDw/wOAPwDA/x8A/wAA/v8B/AMA/P8P/A8A/v8/4D8A/v//538A+P////8A/P////8B/P/////7/P////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8B' };

  /* Enough of India's cities to put a pin on the map. The courier's own
     text decides what is shown; this list only decides where the pin goes. */
  var CITIES = [
    ['mumbai', 19.08, 72.88], ['delhi', 28.61, 77.21], ['new delhi', 28.61, 77.21], ['bengaluru', 12.97, 77.59],
    ['bangalore', 12.97, 77.59], ['hyderabad', 17.39, 78.49], ['chennai', 13.08, 80.27], ['kolkata', 22.57, 88.36],
    ['pune', 18.52, 73.86], ['ahmedabad', 23.02, 72.57], ['jaipur', 26.91, 75.79], ['lucknow', 26.85, 80.95],
    ['kanpur', 26.45, 80.33], ['nagpur', 21.15, 79.09], ['indore', 22.72, 75.86], ['bhopal', 23.26, 77.41],
    ['patna', 25.59, 85.14], ['vadodara', 22.31, 73.19], ['surat', 21.17, 72.83], ['ludhiana', 30.90, 75.86],
    ['agra', 27.18, 78.01], ['nashik', 20.00, 73.79], ['varanasi', 25.32, 82.97], ['ranchi', 23.34, 85.31],
    ['guwahati', 26.14, 91.74], ['chandigarh', 30.73, 76.78], ['coimbatore', 11.02, 76.96], ['kochi', 9.93, 76.27],
    ['thiruvananthapuram', 8.52, 76.94], ['visakhapatnam', 17.69, 83.22], ['bhubaneswar', 20.30, 85.82],
    ['dehradun', 30.32, 78.03], ['amritsar', 31.63, 74.87], ['jodhpur', 26.24, 73.02], ['udaipur', 24.59, 73.71],
    ['raipur', 21.25, 81.63], ['gwalior', 26.22, 78.18], ['jabalpur', 23.18, 79.99], ['mysuru', 12.30, 76.64],
    ['mysore', 12.30, 76.64], ['madurai', 9.93, 78.12], ['vijayawada', 16.51, 80.65], ['guntur', 16.31, 80.44],
    ['noida', 28.54, 77.39], ['gurugram', 28.46, 77.03], ['gurgaon', 28.46, 77.03], ['ghaziabad', 28.67, 77.42],
    ['faridabad', 28.41, 77.31], ['meerut', 28.98, 77.71], ['aligarh', 27.90, 78.08], ['bareilly', 28.37, 79.43],
    ['moradabad', 28.84, 78.78], ['gorakhpur', 26.76, 83.37], ['prayagraj', 25.44, 81.85], ['allahabad', 25.44, 81.85],
    ['muzaffarpur', 26.12, 85.39], ['gaya', 24.79, 85.00], ['bhagalpur', 25.24, 86.98], ['darbhanga', 26.15, 85.90],
    ['bettiah', 26.80, 84.50], ['west champaran', 26.80, 84.50], ['motihari', 26.65, 84.92], ['east champaran', 26.65, 84.92],
    ['siwan', 26.22, 84.36], ['chapra', 25.78, 84.75], ['hajipur', 25.69, 85.21], ['purnia', 25.78, 87.47],
    ['begusarai', 25.42, 86.13], ['ara', 25.56, 84.66], ['dhanbad', 23.80, 86.43], ['jamshedpur', 22.80, 86.20],
    ['bokaro', 23.67, 86.15], ['asansol', 23.68, 86.98], ['durgapur', 23.52, 87.31], ['siliguri', 26.73, 88.40],
    ['howrah', 22.59, 88.31], ['cuttack', 20.46, 85.88], ['rourkela', 22.26, 84.85], ['bilaspur', 22.08, 82.15],
    ['durg', 21.19, 81.28], ['aurangabad', 19.88, 75.34], ['solapur', 17.66, 75.91], ['kolhapur', 16.70, 74.24],
    ['thane', 19.22, 72.98], ['navi mumbai', 19.03, 73.02], ['rajkot', 22.30, 70.80], ['bhavnagar', 21.76, 72.15],
    ['jamnagar', 22.47, 70.06], ['gandhinagar', 23.22, 72.65], ['ajmer', 26.45, 74.64], ['kota', 25.21, 75.86],
    ['bikaner', 28.02, 73.31], ['jalandhar', 31.33, 75.58], ['patiala', 30.34, 76.39], ['shimla', 31.10, 77.17],
    ['jammu', 32.73, 74.87], ['srinagar', 34.08, 74.80], ['haridwar', 29.95, 78.16], ['tiruchirappalli', 10.79, 78.70],
    ['trichy', 10.79, 78.70], ['salem', 11.66, 78.15], ['tirupati', 13.63, 79.42], ['nellore', 14.44, 79.99],
    ['warangal', 17.98, 79.59], ['kozhikode', 11.26, 75.78], ['calicut', 11.26, 75.78], ['thrissur', 10.53, 76.21],
    ['mangaluru', 12.91, 74.86], ['mangalore', 12.91, 74.86], ['hubli', 15.36, 75.12], ['belagavi', 15.85, 74.50],
    ['goa', 15.49, 73.83], ['panaji', 15.49, 73.83], ['agartala', 23.83, 91.28], ['imphal', 24.82, 93.94],
    ['shillong', 25.58, 91.89], ['aizawl', 23.73, 92.72], ['dibrugarh', 27.47, 94.91], ['itanagar', 27.10, 93.62]
  ];

  function place(text) {
    var t = String(text || '').toLowerCase();
    var best = null;
    for (var i = 0; i < CITIES.length; i++) {
      if (t.indexOf(CITIES[i][0]) >= 0 && (!best || CITIES[i][0].length > best[0].length)) best = CITIES[i];
    }
    return best ? { lat: best[1], lon: best[2], known: true } : { lat: INDIA.lat, lon: INDIA.lon, known: false };
  }

  /* unpack the land bits once into a flat list of [lat, lon] */
  function unpack(L) {
    var out = [];
    var bin;
    try { bin = atob(L.b64); } catch (e) { return out; }
    var n = 0, lon0 = L.lon0 != null ? L.lon0 : -180, span = (L.lon1 != null ? L.lon1 : 180) - lon0;
    for (var r = 0; r < L.rows; r++) {
      var lat = L.lat0 + r * L.step, off = (r % 2) ? 0.5 : 0;
      var cols = Math.max(8, Math.floor(span / L.step * Math.cos(lat * Math.PI / 180) + 0.5));
      for (var c = 0; c < cols; c++, n++) {
        var byte = bin.charCodeAt(n >> 3);
        if (byte & (1 << (n & 7))) out.push([lat, lon0 + (c + off) * span / cols]);
      }
    }
    return out;
  }
  var DOTS = unpack(LAND), FINE_DOTS = null;
  function inFine(d) { return d[0] >= FINE.lat0 && d[0] <= FINE.lat1 && d[1] >= FINE.lon0 && d[1] <= FINE.lon1; }

  function Globe(host, opts) {
    opts = opts || {};
    var INK = opts.ink || '#1E4494';          // pins, route, label edge
    var DOT = opts.dot || '#4FC3CE';          // land
    var cv = document.createElement('canvas');
    host.insertBefore(cv, host.firstChild);
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, DPR = 1;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* view: where the globe is looking and how close. lon null = keep turning */
    var view = { lat: 14, lon: 62, zoom: 1, cx: 0.5, cy: 0.5 };
    var goal = { lat: 14, lon: null, zoom: 1, cx: 0.5, cy: 0.5 };
    var spin = reduce ? 0 : -0.055;           // surface drifts left to right
    var dest = null, arcT = 0, running = true, raf = 0, last = 0, dragging = false, dragX = 0, dragY = 0, dragLon = 0, dragLat = 0;
    var self = this;

    // one dot, drawn once, stamped thousands of times
    var sprite = document.createElement('canvas');
    function makeSprite() {
      var s = 24 * DPR;
      sprite.width = s; sprite.height = s;
      var c = sprite.getContext('2d');
      c.clearRect(0, 0, s, s);
      c.beginPath(); c.arc(s / 2, s / 2, s / 2 - 0.5, 0, Math.PI * 2);
      c.fillStyle = DOT; c.fill();
    }

    function size() {
      var r = cv.getBoundingClientRect();
      DPR = Math.min(2, window.devicePixelRatio || 1);
      W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      makeSprite();
    }

    var D = Math.PI / 180;
    var sinLat0 = 0, cosLat0 = 1;
    function project(lat, lon, R, cx, cy, lift) {
      var phi = lat * D, lam = (lon - view.lon) * D;
      var cosPhi = Math.cos(phi), sinPhi = Math.sin(phi), cosLam = Math.cos(lam);
      var cosc = sinLat0 * sinPhi + cosLat0 * cosPhi * cosLam;
      var k = R * (1 + (lift || 0));
      return {
        x: cx + k * cosPhi * Math.sin(lam),
        y: cy - k * (cosLat0 * sinPhi - sinLat0 * cosPhi * cosLam),
        v: cosc
      };
    }

    function roundRect(x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.closePath();
    }

    function pin(p, label, big) {
      // a teardrop marker, tip on the point, with a white label under it
      var s = big ? 1.25 : 1;
      var w = 11 * s, h = 16 * s;
      ctx.save();
      ctx.shadowColor = 'rgba(10,23,48,.25)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
      ctx.beginPath();
      ctx.moveTo(p.x, p.y);
      ctx.bezierCurveTo(p.x - w * 0.2, p.y - h * 0.45, p.x - w, p.y - h * 0.55, p.x - w, p.y - h);
      ctx.arc(p.x, p.y - h, w, Math.PI, 0);
      ctx.bezierCurveTo(p.x + w, p.y - h * 0.55, p.x + w * 0.2, p.y - h * 0.45, p.x, p.y);
      ctx.closePath();
      ctx.fillStyle = INK; ctx.fill();
      ctx.restore();
      ctx.beginPath(); ctx.arc(p.x, p.y - h, w * 0.38, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill();
      if (label) {
        ctx.font = '600 ' + (12 * s) + 'px ' + (getComputedStyle(host).fontFamily || 'sans-serif');
        ctx.textBaseline = 'middle'; ctx.textAlign = 'center';
        var tw = ctx.measureText(label).width, rw = tw + 22 * s, rh = 26 * s;
        var rx = p.x - rw / 2, ry = p.y + 8 * s;
        if (rx < 6) rx = 6; if (rx + rw > W - 6) rx = W - 6 - rw;
        ctx.save();
        ctx.shadowColor = 'rgba(10,23,48,.16)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3;
        roundRect(rx, ry, rw, rh, rh / 2); ctx.fillStyle = '#fff'; ctx.fill();
        ctx.restore();
        ctx.fillStyle = '#0A1730'; ctx.fillText(label, rx + rw / 2, ry + rh / 2 + 0.5);
        ctx.textAlign = 'start';
      }
    }

    // a white callout holding a parcel, floating over the delivery point
    function parcel(p, label) {
      ctx.beginPath(); ctx.arc(p.x, p.y, 6, 0, Math.PI * 2); ctx.fillStyle = INK; ctx.fill();
      ctx.beginPath(); ctx.arc(p.x, p.y, 2.5, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill();
      var s = 60, bx = p.x - s / 2, by = p.y - s - 18;
      ctx.save();
      ctx.shadowColor = 'rgba(10,23,48,.22)'; ctx.shadowBlur = 16; ctx.shadowOffsetY = 6;
      roundRect(bx, by, s, s, 14); ctx.fillStyle = '#fff'; ctx.fill();
      ctx.beginPath(); ctx.moveTo(p.x - 7, by + s - 1); ctx.lineTo(p.x, by + s + 9); ctx.lineTo(p.x + 7, by + s - 1); ctx.closePath(); ctx.fill();
      ctx.restore();
      // the parcel: a small box seen from a corner, in the store's blue
      var cx = p.x, cy = by + s / 2 + 1, a = 14, b = 8, hh = 15;
      function face(pts, fill) { ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]); ctx.closePath(); ctx.fillStyle = fill; ctx.fill(); ctx.stroke(); }
      ctx.lineWidth = 1.5; ctx.lineJoin = 'round'; ctx.strokeStyle = INK;
      face([[cx, cy - hh + b], [cx - a, cy - hh], [cx, cy - hh - b], [cx + a, cy - hh]], '#DCE6F8');
      face([[cx - a, cy - hh], [cx, cy - hh + b], [cx, cy + b + 2], [cx - a, cy + 2]], '#8FA9DE');
      face([[cx + a, cy - hh], [cx, cy - hh + b], [cx, cy + b + 2], [cx + a, cy + 2]], INK);
      ctx.strokeStyle = '#fff'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(cx - a / 2, cy - hh - b / 2); ctx.lineTo(cx + a / 2, cy - hh + b / 2); ctx.lineTo(cx + a / 2, cy + b / 2 + 2); ctx.stroke();
      if (label) {
        ctx.font = '600 12px ' + (getComputedStyle(host).fontFamily || 'sans-serif');
        ctx.textBaseline = 'middle'; ctx.textAlign = 'center';
        var tw = ctx.measureText(label).width, rw = tw + 22, rh = 26, rx = p.x - rw / 2, ry = p.y + 12;
        if (rx < 6) rx = 6; if (rx + rw > W - 6) rx = W - 6 - rw;
        ctx.save(); ctx.shadowColor = 'rgba(10,23,48,.16)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3;
        roundRect(rx, ry, rw, rh, rh / 2); ctx.fillStyle = '#fff'; ctx.fill(); ctx.restore();
        ctx.fillStyle = '#0A1730'; ctx.fillText(label, rx + rw / 2, ry + rh / 2 + 0.5); ctx.textAlign = 'start';
      }
    }

    function draw(now) {
      var cx = W * view.cx, cy = H * view.cy;
      var R = Math.min(W, H) * 0.44 * view.zoom;
      sinLat0 = Math.sin(view.lat * D); cosLat0 = Math.cos(view.lat * D);
      ctx.clearRect(0, 0, W, H);

      // soft shadow under the sphere
      var glow = ctx.createRadialGradient(cx, cy + R * 0.08, R * 0.92, cx, cy + R * 0.08, R * 1.22);
      glow.addColorStop(0, 'rgba(30,68,148,.16)');
      glow.addColorStop(0.6, 'rgba(30,68,148,.05)');
      glow.addColorStop(1, 'rgba(30,68,148,0)');
      ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);

      // the sphere
      var body = ctx.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.05, cx, cy, R);
      body.addColorStop(0, '#EAF7FC');
      body.addColorStop(0.55, '#D2ECF7');
      body.addColorStop(1, '#B4DBEE');
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.fillStyle = body; ctx.fill();

      // land, as dots. Only the facing half; smaller towards the rim.
      var close = view.zoom > 2.2;
      if (close && !FINE_DOTS) FINE_DOTS = DOTS.filter(function (d) { return !inFine(d); }).concat(unpack(FINE));
      var set = close ? FINE_DOTS : DOTS;
      var cell = R * (close ? FINE.step : LAND.step) * D;    // one lattice step, in px
      var base = Math.min(8, Math.max(1.1, cell * 0.66));    // dot diameter, capped when zoomed
      var sp = sprite;
      for (var i = 0; i < set.length; i++) {
        var d = set[i];
        var phi = d[0] * D, lam = (d[1] - view.lon) * D;
        var cosPhi = Math.cos(phi), cosLam = Math.cos(lam);
        var cosc = sinLat0 * Math.sin(phi) + cosLat0 * cosPhi * cosLam;
        if (cosc <= 0.02) continue;
        var x = cx + R * cosPhi * Math.sin(lam);
        var y = cy - R * (cosLat0 * Math.sin(phi) - sinLat0 * cosPhi * cosLam);
        if (x < -base || y < -base || x > W + base || y > H + base) continue;
        var sz = base * (0.55 + 0.45 * cosc);
        ctx.globalAlpha = 0.55 + 0.45 * cosc;
        ctx.drawImage(sp, x - sz / 2, y - sz / 2, sz, sz);
      }
      ctx.globalAlpha = 1;

      // rim
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(30,68,148,.10)'; ctx.lineWidth = 1; ctx.stroke();

      // route from the warehouse to the parcel
      if (dest) {
        var n = 72, route = [];
        for (var r = 0; r <= n; r++) {
          var t = r / n;
          route.push([HUB.lat + (dest.lat - HUB.lat) * t, HUB.lon + (dest.lon - HUB.lon) * t, Math.sin(t * Math.PI) * 0.06]);
        }
        var upto = Math.floor(route.length * Math.min(1, arcT));
        ctx.beginPath(); var pen = false;
        for (var q = 0; q < upto; q++) {
          var pt = project(route[q][0], route[q][1], R, cx, cy, route[q][2]);
          if (pt.v <= 0) { pen = false; continue; }
          if (!pen) { ctx.moveTo(pt.x, pt.y); pen = true; } else ctx.lineTo(pt.x, pt.y);
        }
        ctx.strokeStyle = INK; ctx.lineWidth = Math.max(2, 1.2 * view.zoom); ctx.lineCap = 'round';
        ctx.setLineDash([]); ctx.stroke();
        if (arcT < 1 && upto > 0) {
          var m = project(route[upto - 1][0], route[upto - 1][1], R, cx, cy, route[upto - 1][2]);
          if (m.v > 0) { ctx.beginPath(); ctx.arc(m.x, m.y, 4, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill(); ctx.strokeStyle = INK; ctx.lineWidth = 2; ctx.stroke(); }
        }
        var dp = project(dest.lat, dest.lon, R, cx, cy, 0);
        if (dp.v > 0 && arcT >= 1) {
          var pulse = reduce ? 0.5 : (now / 1500) % 1;
          ctx.beginPath(); ctx.arc(dp.x, dp.y, 6 + pulse * 26, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(30,68,148,' + (0.5 * (1 - pulse)) + ')'; ctx.lineWidth = 2; ctx.stroke();
          parcel(dp, dest.label);
        }
      }

      // the warehouse
      var hp = project(HUB.lat, HUB.lon, R, cx, cy, 0);
      var dpp = dest ? project(dest.lat, dest.lon, R, cx, cy, 0) : null;
      if (hp.v > 0.05 && !(dpp && Math.abs(hp.x - dpp.x) < 70 && Math.abs(hp.y - dpp.y) < 110)) {
        if (!dest) pin(hp, HUB.name, false);
        else { ctx.beginPath(); ctx.arc(hp.x, hp.y, 5, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill(); ctx.strokeStyle = INK; ctx.lineWidth = 2.5; ctx.stroke(); }
      }
    }

    function ease(a, b, k) { return a + (b - a) * k; }
    function shortest(a, b) { var d = ((b - a + 540) % 360) - 180; return a + d; }

    function frame(now) {
      if (!running) return;
      var dt = last ? Math.min(50, now - last) : 16; last = now;
      var k = 1 - Math.pow(0.001, dt / 1600);          // smooth approach, ~1.6s
      if (!dragging) {
        if (goal.lon == null) view.lon += spin * dt / 16;
        else view.lon = ease(view.lon, shortest(view.lon, goal.lon), k);
        view.lat = ease(view.lat, goal.lat, k);
      }
      view.zoom = ease(view.zoom, goal.zoom, k);
      view.cx = ease(view.cx, goal.cx, k);
      view.cy = ease(view.cy, goal.cy, k);
      if (dest && arcT < 1 && Math.abs(view.zoom - goal.zoom) < 0.15) arcT = Math.min(1, arcT + dt / 1400);
      draw(now);
      raf = requestAnimationFrame(frame);
    }

    /* zoom in on India, pin the parcel's city, draw the way there */
    this.focus = function (target, label) {
      dest = { lat: target.lat, lon: target.lon, label: label || '' };
      arcT = 0;
      goal = { lat: target.lat, lon: target.lon, zoom: opts.zoom || 3, cx: opts.zoomCx != null ? opts.zoomCx : 0.5, cy: opts.zoomCy != null ? opts.zoomCy : 0.5 };
    };
    /* ease in while the answer is on its way, no pin yet */
    this.zoomIn = function () { dest = null; arcT = 0; goal = { lat: 22, lon: 80, zoom: opts.zoom || 3, cx: opts.zoomCx != null ? opts.zoomCx : 0.5, cy: opts.zoomCy != null ? opts.zoomCy : 0.5 }; };
    this.rest = function () { dest = null; arcT = 0; goal = { lat: 14, lon: null, zoom: 1, cx: 0.5, cy: 0.5 }; };
    /* auto is the page itself pausing for a hidden tab or a scrolled-away
       globe; without it, it is the tracking page parking the globe for good
       once the map has taken over. A parked globe must not come back to life
       the next time the tab is looked at - it is behind the map by then. */
    var parked = false;
    this.start = function (auto) {
      if (auto && parked) return;
      if (!auto) parked = false;
      if (!raf) { running = true; last = 0; raf = requestAnimationFrame(frame); }
    };
    this.stop = function (auto) {
      if (!auto) parked = true;
      running = false; if (raf) cancelAnimationFrame(raf); raf = 0;
    };

    // the globe turns whichever way it is dragged, and stays where it is left
    cv.style.touchAction = 'none';
    cv.addEventListener('pointerdown', function (e) { dragging = true; dragX = e.clientX; dragY = e.clientY; dragLon = view.lon; dragLat = view.lat; try { cv.setPointerCapture(e.pointerId); } catch (x) {} });
    cv.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      /* The land goes the way the hand goes, and by the distance the hand
         goes: one pixel of drag is one pixel of sphere, which is what makes
         it feel like the planet is being pushed round rather than nudged.
         Both directions used to be the wrong way about, so it turned away
         from the finger, and the step was a flat guess that was too fast on
         a wide screen and too slow on a phone. */
      var R = Math.min(W, H) * 0.44 * view.zoom;
      var perPx = 57.29577951 / Math.max(1, R);
      view.lon = dragLon - (e.clientX - dragX) * perPx;
      view.lat = Math.max(-80, Math.min(80, dragLat + (e.clientY - dragY) * perPx));
    });
    function up() { if (!dragging) return; dragging = false; goal.lat = view.lat; if (goal.lon != null) goal.lon = view.lon; }
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up);

    size();
    window.addEventListener('resize', size);
    document.addEventListener('visibilitychange', function () { if (document.hidden) self.stop(true); else self.start(true); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) self.start(true); else self.stop(true); }).observe(host);
    } else this.start();
  }

  window.__axGlobe = { HUB: HUB, INDIA: INDIA, CITIES: CITIES, place: place, Globe: Globe };
})();
